import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconLayoutGrid",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--layout-grid"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Layout Grid",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 1.5a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5H1.5A.5.5 0 0 1 1 5V1.5ZM2 2v2.5h2.5V2H2Zm4.5-.5A.5.5 0 0 1 7 1h3.5a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V1.5Zm1 .5v2.5H10V2H7.5Zm-1 5a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V7Zm1 .5V10H10V7.5H7.5ZM1 7a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5H1.5a.5.5 0 0 1-.5-.5V7Zm1 .5V10h2.5V7.5H2Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const h = /* @__PURE__ */ s(c, [["render", u]]);
export {
  h as default
};
//# sourceMappingURL=layout-grid.js.map
